export default __webpack_public_path__ + "static/media/pere.abf4a0be.jpeg";